import React, { useMemo } from 'react';
import { Table } from 'antd';

import { getColumns } from '../utils/getColumns';
import { VisitorsProps } from '../service/visitors.interface';
import { setTransformData } from '../utils/setTransformData';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';

export const VisitorsTable = (
    props: CommonTableProps<VisitorsProps, CommonFiltersProps>
) => {
    const { source, loading, filters, updateFilters } = props;

    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Рассылок'
            ),
        [filters, updateFilters, source?.total]
    );

    const transformedData = useMemo(() => {
        return setTransformData(source);
    }, [source]);

    return (
        <Table
            loading={loading}
            pagination={pagination}
            dataSource={transformedData?.items}
            rowKey={record => record.authDate + record.telegramUserId}
            columns={getColumns()}
        />
    );
};
